var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfAssessment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_2656)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9 12.006c2.462.129 4.42 2.237 4.42 4.817l-.006.248a4.893 4.893 0 01-1.156 2.936l2.633 2.724a.75.75 0 01-1.022 1.095l-.056-.052-2.697-2.79a4.518 4.518 0 01-2.356.661l-.24-.005c-2.383-.125-4.293-2.103-4.414-4.569L13 16.823C13 14.16 15.086 12 17.66 12l.24.006zm-.24 1.494c-1.697 0-3.16 1.44-3.16 3.323 0 1.884 1.463 3.322 3.16 3.322s3.16-1.438 3.16-3.322c0-1.884-1.463-3.323-3.16-3.323z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.646 13.139h.01c-.32.456-.58.955-.773 1.488-3.084.025-4.793 1.057-5.786 2.152-.793.874-1.216 1.887-1.442 2.721h7.426c.25.546.572 1.05.956 1.5H3.912l-.102-.005c-.503-.051-.882-.477-.798-.988C3.36 17.89 4.93 13.125 12 13.125l.646.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.233 3.006c2.401.12 4.311 2.086 4.311 4.494l-.006.231C16.416 10.11 14.431 12 12 12l-.233-.006c-2.401-.12-4.31-2.086-4.31-4.494C7.456 5.015 9.49 3 12 3l.233.006zM12 4.5c-1.695 0-3.044 1.357-3.044 3s1.35 3 3.044 3c1.695 0 3.044-1.357 3.044-3s-1.35-3-3.044-3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_2656"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgSelfAssessment.displayName = 'SelfAssessment';
export default SvgSelfAssessment;